import { Button } from 'primereact/button';
import { Sidebar } from 'primereact/sidebar';
import {
  CartItemInput,
  CartItemInterface,
  useAddProductsToCartMutation,
} from 'graphql/generated/magentoApi';
import { Dialog } from 'primereact/dialog';
import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { ReactElement, useState } from 'react';
// import { ToggleButton } from 'primereact/togglebutton';
import { useCartContext } from 'CartContext';
import buttonize from 'utils/buttonize';
import Product from 'components/Product';
import ReactGA from 'react-ga4';
import Slider from 'react-slick';
import { getMarketContent } from 'utils/marketContent';
import RightSidebarCart from '../../../components/right-sidebar-cart';
import './index.scss';

export default function NewArrivals(): ReactElement {
  const [searchParams] = useSearchParams();
  const openSku = searchParams.get('openSku');
  const [displayBasic, setDisplayBasic] = useState(!!openSku);
  const [dialogPackage, setDialogPackage] = useState(openSku || '');
  const [visibleSideCart, setVisibleSideCart] = useState<boolean>(false);
  const market = getMarketContent();
  const data = market.homePage.productCarousel;
  const marketName = market.market;

  const navigate = useNavigate();

  const onClick = (sku?: string) => {
    setDisplayBasic(!displayBasic);
    setDialogPackage(sku || '');
    if (sku) {
      navigate(`?openSku=${sku}`);
    } else {
      navigate('');
    }
  };

  interface BlogSiteProduct {
    index: number;
    thumbnail: string;
    name: string;
    price: string;
    sku?: string;
  }

  const ProductCard = ({ thumbnail, name, price, sku }: BlogSiteProduct) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [addProductState, setAddProductState] =
      useAddProductsToCartMutation();
    const { cartId, updateItems } = useCartContext();

    // TODO: figure out why addProductState doesn't change after setAddProductState call
    // useEffect(() => {
    //   const items = addProductState.data?.addProductsToCart?.cart.items as
    //     | CartItemInterface[]
    //     | undefined;
    //   if (!addProductState.fetching && items?.length) {
    //     updateItems([...items]);
    //   } else if (addProductState.error) {
    //     reset();
    //   }
    // }, [addProductState]);

    const onClickAddBtn = (e: any, sku: string, quantity?: number) => {
      if (e) e.stopPropagation();
      setVisibleSideCart(true);
      setAddProductState({
        cartId,
        cartItems: [
          {
            sku,
            quantity: quantity || 1,
          },
        ] as CartItemInput[],
      }).then(data => {
        const newItems = data.data?.addProductsToCart.cart.items || [];
        updateItems(newItems as unknown as CartItemInterface[]);
      });
      ReactGA.event({
        category: 'ecommerce',
        action: 'add_to_cart',
        label: `Product Card Action ${sku}`,
      });
    };

    return (
      <>
        <div className="arrival-product-card">
          <div className="img-wrapper">
            <img src={thumbnail} alt="thumbnail" />
            <div className="product-label">
              {/* {index === 0 && <Tag severity="success" value="Sale!" />}
            {index === 7 && <Tag severity="danger" value="Hot" />} */}
            </div>
            <div className="img-overlay" {...buttonize(() => onClick(sku))}>
              {/* <div className="product-add-to-wishlist">
                <ToggleButton
                  onIcon="pi pi-heart-fill"
                  offIcon="pi pi-heart"
                  onLabel=""
                  offLabel=""
                  checked={checked1}
                  onChange={e => setChecked1(e.value)}
                />
              </div> */}
              <div className="product-actions">
                <Button
                  label="Add to Cart"
                  className="c-button-gray mb-3"
                  onClick={(e: any) => onClickAddBtn(e, sku || '')}
                />
                {/* <Rating value={4} readOnly stars={5} cancel={false} /> */}
              </div>
              <div className="product-quickview">
                <span>Quick View</span>
              </div>
            </div>
          </div>
          <div className="content">
            <p className="product-title">{name}</p>
            <span className="price">
              <ins>
                <span className="amount">{price}</span>
              </ins>
            </span>
            <div className="button--wraper flex md:hidden align-items-center w-full my-3 mx-auto">
              <Link
                to={`/product/${sku}`}
                className="shop-button green solid mx-auto"
              >
                Quick View
              </Link>
            </div>
          </div>
        </div>
      </>
    );
  };

  function PrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
        }}
        role="button"
        aria-label="Press enter to view next item"
        tabIndex={0}
        onClick={onClick}
        onKeyPress={onClick}
      >
        <FontAwesomeIcon icon={faChevronLeft} />
      </div>
    );
  }

  function NextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
        }}
        role="button"
        aria-label="Press enter to view next item"
        tabIndex={0}
        onClick={onClick}
        onKeyPress={onClick}
      >
        <FontAwesomeIcon icon={faChevronRight} />
      </div>
    );
  }

  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 4,
    speed: 500,
    rows: 1,
    slidesPerRow: 2,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 960,
        settings: {
          arrows: true,
          slidesToShow: 1,
          speed: 500,
          rows: 1,
          slidesPerRow: 1,
        },
      },
      {
        breakpoint: 961,
        settings: {
          arrows: true,
          slidesToShow: 2,
          speed: 500,
          rows: 1,
          slidesPerRow: 1,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          arrows: true,
          slidesToShow: 2,
          speed: 500,
          rows: 1,
          slidesPerRow: 2,
        },
      },
    ],
  };

  return (
    <>
      <section
        id="new-arrivals"
        className={marketName === 'advancedmedicine' ? '' : 'hidden'}
      >
        <div className="container px-4 md:px-8 xl:px-0">
          <h2 className="section_header text-900">New Arrivals</h2>
          <Sidebar
            className="w-1/5 sm:w-auto cart-summary__sidebar"
            visible={visibleSideCart}
            position="right"
            closeOnEscape
            showCloseIcon={false}
            onHide={() => setVisibleSideCart(false)}
          >
            <RightSidebarCart setVisibleRight={setVisibleSideCart} />
          </Sidebar>
          <Slider {...settings}>
            {data.map(item => (
              <ProductCard {...item} key={item.sku} />
            ))}
          </Slider>
        </div>
        <Dialog
          visible={displayBasic}
          breakpoints={{ '960px': '80vw', '640px': '90vw' }}
          style={{ height: '80vh', width: '70vw' }}
          position="center"
          dismissableMask
          draggable={false}
          onHide={onClick}
        >
          <Product sku={dialogPackage} />
        </Dialog>
      </section>
    </>
  );
}
